<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemMenu.query.menuName')">
                <a-input v-model="queryParam.menuName" :placeholder="$t('views.systemMenu.query.menuNamePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.systemMenu.query.status')">
                <a-select :placeholder="$t('views.systemMenu.query.statusPlaceholder')" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in localizedStatusOptions" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.systemMenu.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.systemMenu.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['system:menu:add']">
          <a-icon type="plus" />{{ $t('views.systemMenu.btn.add') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form
        ref="createForm"
        :menuOptions="menuOptions"
        :statusOptions="dict.type['sys_enable_disable']"
        :visibleOptions="dict.type['sys_show_hide']"
        @ok="getList"
        @select-tree="getTreeselect"
      />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="displayColumns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered">
        <span slot="menuName" slot-scope="text">
          {{ renderMenuName(text) }}
        </span>
        <span slot="icon" slot-scope="text">
          <a-icon :component="allIcon[text + 'Icon']" v-if="allIcon[text + 'Icon']"/>
          <a-icon :type="text" v-if="!allIcon[text + 'Icon']"/>
        </span>
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="localizedStatusOptions" :value="record.status" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['system:menu:edit']" />
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['system:menu:edit']">
            <a-icon type="edit" />{{ $t('views.systemMenu.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['system:menu:add']" />
          <a @click="$refs.createForm.handleAdd(record)" v-hasPermi="['system:menu:add']">
            <a-icon type="plus" />{{ $t('views.systemMenu.btn.add') }}
          </a>
          <a-divider type="vertical" v-if="record.id != 0" v-hasPermi="['system:menu:remove']" />
          <a @click="handleDelete(record)" v-if="record.id != 0" v-hasPermi="['system:menu:remove']">
            <a-icon type="delete" />{{ $t('views.systemMenu.btn.delete') }}
          </a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>

import { listMenu, delMenu } from '@/api/system/menu'
import CreateForm from './modules/CreateForm'
import allIcon from '@/core/icons'
import { tableMixin } from '@/store/table-mixin'
import { i18nRender, localizeMenuTree } from '@/locales'

export default {
  name: 'Menu',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable', 'sys_show_hide'],
  data () {
    return {
      allIcon,
      list: [],
      menuOptionsRaw: [],
      loading: false,
      queryParam: {
        menuName: undefined,
        status: undefined
      },
      columns: [
        {
          title: '',
          dataIndex: 'menuName',
          scopedSlots: { customRender: 'menuName' },
          ellipsis: true,
          width: '15%'
        },
        {
          title: '',
          dataIndex: 'icon',
          scopedSlots: { customRender: 'icon' },
          width: '5%',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'orderNum',
          width: '5%',
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'perms',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'component',
          scopedSlots: { customRender: 'component' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'createTime',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '',
          dataIndex: 'operation',
          width: '20%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    localizedStatusOptions () {
      return this.localizeDictOptions(this.dict.type['sys_enable_disable'], 'views.systemMenu.dict.status')
    },
    menuOptions () {
      return [{
        id: 0,
        menuName: this.$t('views.systemMenu.rootDir'),
        children: localizeMenuTree(this.menuOptionsRaw, 'menuName')
      }]
    },
    displayColumns () {
      const titleKeyByDataIndex = {
        menuName: 'views.systemMenu.column.menuName',
        icon: 'views.systemMenu.column.icon',
        orderNum: 'views.systemMenu.column.orderNum',
        perms: 'views.systemMenu.column.perms',
        component: 'views.systemMenu.column.component',
        status: 'views.systemMenu.column.status',
        createTime: 'views.systemMenu.column.createTime',
        operation: 'views.systemMenu.column.operation'
      }
      return this.columns.map(col => {
        const key = titleKeyByDataIndex[col.dataIndex]
        return {
          ...col,
          title: key ? this.$t(key) : col.title
        }
      })
    }
  },
  methods: {
    renderMenuName (name) {
      return i18nRender(name)
    },
    localizeDictOptions (options, keyPrefix) {
      return (options || []).map(item => {
        const i18nKey = `${keyPrefix}.${item.value}`
        return {
          ...item,
          label: this.$te(i18nKey) ? this.$t(i18nKey) : item.label
        }
      })
    },
    getList () {
      this.loading = true
      listMenu(this.queryParam).then(response => {
        this.list = this.handleTree(response.data, 'id')
        this.loading = false
      })
    },
    handleQuery () {
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        menuName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    getTreeselect () {
      listMenu().then(response => {
        this.menuOptionsRaw = this.handleTree(response.data, 'id')
      })
    },
    handleDelete (row) {
      const that = this
      const menuId = row.id
      this.$confirm({
        title: this.$t('views.systemMenu.confirm.deleteTitle'),
        content: this.$t('views.systemMenu.confirm.deleteContent', { ids: menuId }),
        onOk () {
          return delMenu(menuId)
            .then(() => {
              that.getList()
              that.$message.success(that.$t('views.systemMenu.msg.deleteSuccess'), 3)
            })
        },
        onCancel () {}
      })
    }
  }
}
</script>
